import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Content from '@/components/Content/Content'
import PrivacyPolicy from '../views/PrivacyPolicy/PrivacyPolicy.vue'
import TermsOfServie from '../views/TermsOfServie/TermsOfServie.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/',
        name: 'main',
        component: Content,
      },
      {
        path: '/privacypolicy',
        name: 'Privacypolicy',
        component: PrivacyPolicy
      },
      {
        path: '/service',
        name: 'Service',
        component: TermsOfServie
      },
    ]
  },
  

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
